module.exports = __webpack_public_path__ + "static/img/logo_044.91209b48.png";